/* eslint-disable no-undef */
/* eslint-disable no-console */

(function ($) {
	"use strict";

	/**
	 * Show / Hide the mobile header menu bar.
	 */
	function mobile_menu_bar() {

		var $t = $('#mobile-corner-menu');
		var screen_height = window.innerHeight - $('.header-bar').height();

		$('#mobile-corner-menu').css('max-height', screen_height + 'px');

		if ($t.is(':visible')) {
			$t.slideUp(400);
			// $('body').css('overflow', 'visible');
		} else {
			$t.slideDown(400);
			// $('body').css('overflow', 'hidden');
		}
	}

	$(function () {
		// console.log(
		// 	"Width:" +
		// 		viewportSize.getWidth() +
		// 		", Height: " +
		// 		viewportSize.getHeight()
		// );



		/**
		 * Load doubleTapToGo plugin.
		 */
		$('#navbarNavDropdown').doubleTapToGo();



		/**
		 * Accordion, initial setup.
		 */
		if ($('.acf_accordion').length > 0) {

			$('.toggle').click(function (e) {
				e.preventDefault();

				var $this = $(this);

				if ($this.hasClass('show')) {
					$this.removeClass('show').attr('aria-expanded', 'false');
				} else {
					$this.removeClass('show');
					$this.addClass('show').attr('aria-expanded', 'true');
				}

				if ($this.next().hasClass('show')) {
					$this.next().removeClass('show').attr('aria-hidden', 'true');
					$this.next().slideUp(350);
				} else {
					$this.parent().parent().find('li .inner').removeClass('show');
					$this.parent().parent().find('li .inner').slideUp(350);
					$this.next().toggleClass('show').attr('aria-hidden', 'false');
					$this.next().slideToggle(350);
				}
			});

		}





		/**
		 * Show / Hide the Mobile menu bar.
		 */
		$(".mobile-menu > a").click(function (e) {
			e.preventDefault();
			/**
			 * Open mobile menu.
			 */

			mobile_menu_bar();
			$(this).find('.middle').toggle();
			$(this).find('.top').toggleClass('rotate');
			$(this).find('.bottom').toggleClass('rotate');
		});




		/**
		 * Background Slideshow with rolling highlighed caption.
		 */

		// Function to highlight the next list item and reset others
		function highlightNextItem() {
			$listItems.removeClass('highlighted');
			$listItems.eq(currentIndex).addClass('highlighted');
			currentIndex = (currentIndex + 1) % $listItems.length;
		}

		if ($('body:not(.wp-admin)').length > 0) {
			// https://chat.openai.com/c/b82bd4b4-398d-4024-926e-ab7aa9220bef
			// jquery find code that displays a list and every 5 seconds highlights one list item
			var $listItems = $('#animated-text li');
			var currentIndex = 0;

			// Initially highlight the first item
			highlightNextItem();

			// Set an interval to highlight every 5 seconds
			setInterval(highlightNextItem, 30000);
			//
		}

	});






	if ($('#slideshow-text-expand').length > 0) {

		// https://github.com/bqworks/accordion-slider-jquery
		$('#my-accordion').accordionSlider({
			autoplay: true,
			autoplayDelay: 4000,
			width: "100%", // base width of the accordion slider
			height: "660px", // base height of the accordion slider
			visiblePanels: 4,
			startPanel: 0,
			openedPanelSize: "max",
			mouseWheel: false,
			mouseWheelTarget: "page",
			keyboardTarget: "page",
			openPanelDuration: 700, // Determines the duration in milliseconds for the opening of a panel.
			closePanelDuration: 700, // Determines the duration in milliseconds for the closing of a panel.
			breakpoints: {
				// up to...
				992: {height: "600px",},
				768: {height: "500px", openedPanelSize: "74%",},
				500: {height: "300px", openedPanelSize: "60%",}
			},
			init: function() {
				$('#my-accordion .as-panels .as-panel .as-layer.title.location').addClass('closed');
			},
			panelOpen: function() {
				$('#my-accordion .as-panels .as-panel .as-layer.title.location').removeClass('closed');
			},
			panelClick: function() {
				if ( ! $('#my-accordion .as-panels .as-panel').hasClass('as-opened' )) {
					$('#my-accordion .as-panels .as-panel.active').removeClass('active');
					$('#my-accordion .as-panels .as-panel .as-layer.title.location').addClass('closed');
				}
			},
			panelOpenComplete: function(event) {
				$('#my-accordion .as-panels .as-panel.as-opened').addClass('active');
				$('#my-accordion .as-panels .as-panel.as-opened .as-layer.panel-counter').addClass('closed');
				$('#my-accordion .as-panels .as-panel.as-opened .as-layer.title.location').show();
			}
		});
	}



	if ( $('#slideshow-text').length > 0 ) {

		var initializeBlock_g__animated_text = function ($block) {
			var $slider = $('#slideshow-text');
			$slider.slick({
				slidesToShow: 1,
				autoplay: true,
				arrows: false,
				dots: false,
				autoplaySpeed: 4000,
				speed: 100,
				infinite: false,
				fade: true,
			});
		}

		$('#slideshow-text').on('init', function (event, slick) {
			var get_title = $(this).find('.slide.slick-current figure').data('location');

			$('#locations li').removeClass('active');
			$('#locations li[data-location-title="' + get_title + '"]').addClass('active');

		});

		$('#slideshow-text').on('afterChange', function(event, slick, currentSlide){
			var get_title = $(this).find('.slide.slick-current figure').data('location');

			$('#locations li').removeClass('active');
			$('#locations li[data-location-title="' + get_title + '"]').addClass('active');
		});

	}






	var initializeBlock_g__advisors_text = function ($block) {
		var $slider = $('#slideshow-advisors');
		$slider.slick({
			slidesToShow: 5,
			autoplay: false,
			arrows: false,
			dots: true,
			autoplaySpeed: 3000,
			speed: 600,
			infinite: true,
			fade: false,
			responsive: [
				{
					breakpoint: 991, // up to.
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 767, // up to.
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 567, // up to.
					settings: {
						slidesToShow: 1,
						adaptiveHeight: true
					}
				},
			]
		});
	}

	var initializeBlock_g__acf_hero_slideshow = function ($block) {
		var $slider = $('#slideshow-hero');
		$slider.slick({
			slidesToShow: 1,
			autoplay: true,
			arrows: false,
			dots: false,
			autoplaySpeed: 3000,
			speed: 600,
			infinite: true,
			fade: true,
		});
	}

	$(window).load(function () {
		if (
			$('#slideshow-text').length > 0 &&
			$('body:not(.wp-admin)').length > 0
		) {
			$('#slideshow-text').each(function(){
				initializeBlock_g__animated_text( $(this) );
			});
		}

		if (
			$('#slideshow-advisors').length > 0 &&
			$('body:not(.wp-admin)').length > 0
		) {
			$('#slideshow-advisors').each(function(){
				initializeBlock_g__advisors_text( $(this) );
			});
		}

		if (
			$('#acf-hero-slideshow').length > 0 &&
			$('body:not(.wp-admin)').length > 0
		) {
			$('#acf-hero-slideshow').each(function(){
				initializeBlock_g__acf_hero_slideshow( $(this) );
			});
		}
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		// window.acf.addAction( 'render_block_preview/type=animated-text', initializeBlock_g__animated_text );

		// window.acf.addAction( 'render_block_preview/type=advisors-text', initializeBlock_g__advisors_text );
	}

})(jQuery);